import { render, staticRenderFns } from "./CompraDiretaLegadaDetalhes.vue?vue&type=template&id=4890feff&scoped=true"
import script from "./CompraDiretaLegadaDetalhes.vue?vue&type=script&lang=js"
export * from "./CompraDiretaLegadaDetalhes.vue?vue&type=script&lang=js"
import style0 from "./CompraDiretaLegadaDetalhes.vue?vue&type=style&index=0&id=4890feff&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890feff",
  null
  
)

export default component.exports